import { motion } from "framer-motion";
import { SlidersHorizontal, Repeat, Users, Zap, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const ICONS = [SlidersHorizontal, Repeat, Users, Zap];

const Values = () => {
  const { t } = useLang();
  const v = t.values;

  return (
    <section className="values section-dark" aria-labelledby="values-title" data-testid="values-section">
      <div className="values-glow" aria-hidden="true"></div>
      <div className="shell">
        <div className="values-intro">
          <Reveal className="section-index" aria-hidden="true">{v.index}</Reveal>
          <Reveal><p className="kicker">{v.kicker}</p></Reveal>
          <h2 id="values-title" className="display-title">
            <LineMask delay={0.1}>{v.titleA}</LineMask>
            <LineMask delay={0.22}><span>{v.titleB}</span></LineMask>
          </h2>
        </div>
        <div className="values-grid">
          {v.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.article
                key={item.title}
                className="value-card"
                initial={{ opacity: 0, y: 34 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.09, ease: [0.2, 0.7, 0.2, 1] }}
                data-testid={`value-${i}`}
              >
                <div className="value-top">
                  <span className="value-icon"><Icon size={19} strokeWidth={2.2} /></span>
                  <span className="value-idx">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <span className="value-arrow" aria-hidden="true"><ArrowUpRight size={16} /></span>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Values;
